import React from 'react';
import PropTypes from 'prop-types';
import {graphql} from 'gatsby';
import Layout from '../Layout/Layout';
import Card from '../Card/Card';
import ArchiveNavigation from './ArchiveNavigation';
import Meta from '../Meta/Meta';
import Breadcrumbs from '../Breadcrumbs/Breadcrumbs';
import {pressReleaseTypes} from '../../types/types';
import './ArchivePage.less';

export default function ArchivePage({data, pageContext, location}) {
    const homeTitle = data.contentfulHome.pageTitle;
    const {contentfulTranslations: translations} = data;

    return (
        <Layout className="main section" {...pageContext}>
            <Meta
                title={`${pageContext.year} | ${translations.pressReleaseArchive}`}
                description={translations.metaDescriptionArchives}
            />
            <div className="ArchivePage container--pr">
                <Breadcrumbs
                    homeTitle={homeTitle}
                    archiveYear={pageContext.year}
                    archiveSlug={pageContext.archiveSlug}
                    translations={translations}
                />
                <h1>{translations.pressReleaseArchive}</h1>
                <ArchiveNavigation
                    years={pageContext.years}
                    pathname={location.pathname}
                    slug={pageContext.archiveSlug}
                />
            </div>
            <section className="ArchiveSection container--pr">
                <h2>{pageContext.year}</h2>
                <div className="ArchiveSection__grid">
                    {data.allContentfulPressRelease.nodes.map((node) => (
                        <Card key={node.id} size="small" {...node} />
                    ))}
                </div>
            </section>
        </Layout>
    );
}

ArchivePage.propTypes = {
    data: PropTypes.shape({
        contentfulHome: PropTypes.shape({
            pageTitle: PropTypes.string.isRequired,
        }),
        allContentfulPressRelease: PropTypes.shape({
            nodes: PropTypes.arrayOf(
                PropTypes.shape({
                    ...pressReleaseTypes,
                    year: PropTypes.string.isRequired,
                    publicationDate: PropTypes.string.isRequired,
                }),
            ).isRequired,
        }).isRequired,
        contentfulTranslations: PropTypes.shape({
            pressReleaseArchive: PropTypes.string.isRequired,
            metaDescriptionArchives: PropTypes.string.isRequired,
        }).isRequired,
    }).isRequired,
    pageContext: PropTypes.shape({
        years: PropTypes.arrayOf(PropTypes.string).isRequired,
        archiveSlug: PropTypes.string.isRequired,
    }),
};

export const query = graphql`
    query ArchiveQuery($ids: [String], $contentfulLocale: String) {
        contentfulHome(locale: {eq: $contentfulLocale}) {
            pageTitle
        }
        contentfulTranslations(node_locale: {eq: $contentfulLocale}) {
            pressReleases
            pressReleaseArchive
            metaDescriptionArchives
        }
        allContentfulPressRelease(
            filter: {
                id: {in: $ids}
                node_locale: {eq: "en-US"}
                locale: {eq: $contentfulLocale}
            }
            sort: {fields: publicationDate, order: DESC}
        ) {
            nodes {
                ...PressReleaseFields
                publicationDate(formatString: "LL", locale: $contentfulLocale)
                year: publicationDate(formatString: "YYYY")
            }
        }
    }
`;
